export default __webpack_public_path__ + "static/media/development-icon.101389df.svg";